// Provides the `React` global that the legacy EUI React.createClass components
// (and the data-react-class mounter) reference as a free variable.
//
// Under Sprockets, react-rails exposed a global `React` that still carried
// `React.createClass` / `React.PropTypes`. React 16 removed both (extracted to
// the create-react-class and prop-types packages), so index.js monkey-patches
// them back onto window.React. But the legacy components live in a split common
// chunk that can evaluate before index.js runs, so relying on window.React is
// load-order-fragile ("Uncaught ReferenceError: React is not defined").
//
// Injecting this module for every free `React` reference via ProvidePlugin makes
// each legacy module import a createClass-capable React directly, independent of
// chunk load order. It patches the same singleton `react` instance that the
// modern ES-module components import, so there is exactly one React.
import React from "react";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";

if (!React.createClass) {
  React.createClass = createReactClass;
}
if (!React.PropTypes) {
  React.PropTypes = PropTypes;
}

export default React;
